<div class="dvb-click-2-edit">
    <div ng-transclude="labelPart" ng-if="!vm.editMode"></div>
    <div ng-transclude="contentPart" ng-if="vm.editMode"></div>
</div>
